import { useRef, useEffect } from 'react';
import { useWheelNavigation } from '../hooks/useWheelNavigation';

export const CenterMenu = ({ activeMenuLevel, currentItemsData, selectedIndex, setSelectedIndex, flatItems, handleItemSelect, masterSearch, setMasterSearch, isDisabled, labels }: any) => {
  const scrollContainerRef = useRef(null);
  useWheelNavigation(scrollContainerRef, flatItems.length, setSelectedIndex, isDisabled, () => !isDisabled && flatItems && flatItems[selectedIndex] && handleItemSelect(flatItems[selectedIndex], selectedIndex));

  // Expose setMasterSearch globally so header search can control it
  useEffect(() => {
    (window as any).__setMasterSearch = (val: string) => {
      if (!isDisabled) setMasterSearch(val);
    };
    return () => { delete (window as any).__setMasterSearch; };
  }, [setMasterSearch, isDisabled]);
  
  const getHeaderTitle = () => {
    return labels[activeMenuLevel] || 'Menu';
  };

  let absoluteIndex = 0;
  return (
    <div className="w-[340px] flex flex-col bg-white border-r border-gray-200 overflow-hidden shrink-0">
      <div className={`w-full h-full flex flex-col ${isDisabled ? 'opacity-80 grayscale-[20%]' : ''}`}>

        <div className="bg-gradient-to-b from-[#1e8585] to-[#177272] text-white py-2.5 font-semibold text-[13px] tracking-wide z-10 flex items-center px-5 gap-2">
          <div className="w-1.5 h-1.5 rounded-full bg-white/50" />
          <span>{getHeaderTitle()}</span>
        </div>

        <div ref={scrollContainerRef} className="flex-1 overflow-y-auto py-2 bg-white no-scrollbar">
          {currentItemsData.map((group: any, gIdx: number) => (
            <div key={gIdx} className="mb-1">
              {group.group && (
                <div className="flex items-center gap-2 px-5 pt-3 pb-1">
                  <div className="w-[3px] h-3 rounded-full bg-[#1e8585]" />
                  <span className="text-[10px] font-bold text-[#1e8585] uppercase tracking-[0.15em]">{group.group}</span>
                  <div className="flex-1 h-px bg-gray-100 ml-1" />
                </div>
              )}
              {group.items.map((item: any, iIdx: number) => {
                const currentIndex = absoluteIndex++;
                const isSelected = currentIndex === selectedIndex;

                return (
                  <div key={iIdx} onClick={() => !isDisabled && handleItemSelect(item, currentIndex)}
                    className={`cursor-pointer flex items-center gap-2 px-5 py-[4px] text-[13px] transition-colors ${
                      isSelected ? 'bg-[#1e8585] text-white font-medium active-row' : 'text-gray-700 hover:bg-[#f0fdfa]'
                    }`}>
                    <div className={`w-1 h-1 rounded-full flex-shrink-0 ${isSelected ? 'bg-white/60' : 'bg-gray-300'}`} />
                    <span className="pl-2">
                      {item.name.split('').map((char: string, charIdx: number) => {
                        const isHotkey = charIdx === item.hotkeyIdx;
                        return <span key={charIdx} className={isHotkey ? (isSelected ? 'font-bold text-[#ccfbf1]' : 'font-bold text-[#1e8585]') : ''}>{char}</span>;
                      })}
                    </span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};